import { ComponentTemplatePrivacyType } from "@growth-machine-llc/stridist-api-client";

export const ComponentTemplatePrivacyTypeLabels = {
  [ComponentTemplatePrivacyType.ALL]: "All",
  [ComponentTemplatePrivacyType.PRIVATE]: "Private",
  [ComponentTemplatePrivacyType.PUBLIC]: "Public",
};
